export function ErrorPage() {
  return <div>Error</div>;
}
